/**
 * Get the amount of items to display in the DataToggleList skeleton loader
 * @return {Number}
 */
function getColumnNumber(
  compareMode: string | undefined,
  countryIds: string[],
  entityIds: string[],
  trends?: any[]
): number {
  if (compareMode) {
    if (compareMode === 'country') return countryIds.length;
    if (compareMode === 'entity') return entityIds.length;
  }

  if (Array.isArray(trends)) {
    return trends.length;
  }

  return entityIds.length;
}

export default getColumnNumber;
